/* eslint-disable @typescript-eslint/no-throw-literal */
import { ref } from 'vue';
import AccessApi from 'SharedDir/backend/api/classes/access.api';
import { useBanner } from 'SharedDir/components/base/Banner/useBanner';
import { YANDEX_CAPTCHA_SHOW } from 'SharedDir/constants/common';

import { makeRequest } from './useRequests';

export function useYandexCaptcha() {
  const showCaptcha = ref(YANDEX_CAPTCHA_SHOW);
  const userToken = ref('');
  const validationState = ref(false);
  const banner = useBanner();

  const checkCaptchaValidation = async () => {
    userToken.value = (<HTMLInputElement>document.getElementsByName('smart-token')[0]).value;
    try {
      // Проверка на то, что пользователь в принципе нажал кнопку проверки
      if (!userToken.value) {
        throw 'Пожалуйста, пройдите проверку. Для этого нажмите "Я не робот"';
      }

      const response = await makeRequest(async () => AccessApi.checkYandexCaptcha(userToken.value));

      validationState.value = response.data.status === 'ok';
      banner.hideBanner();
    } catch (e: any) {
      // Обрабатываем ошибку и записываем её в баннер
      banner.showErrorText(
        // eslint-disable-next-line max-len
        'Ошибка проверки Yandex SmartCaptcha. Пожалуйста, убедитесь, что пройдено испытание и повторите попытку'
      );

      throw e;
    }
  };

  return {
    showCaptcha,
    banner,
    validationState,
    checkCaptchaValidation,
  };
}
